var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.errors && _vm.errors.length)?_c('span',[_c('small',{staticClass:"error",domProps:{"textContent":_vm._s(_vm.errors[0])}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }